import { PlusInSquareIcon } from "assets/icons";
import { If } from "components";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteInventoryBoxQrModal,
  InventoryBoxQrModal,
  InventoryBoxesQrsTable
} from "../../components";
import { useInventoryBoxesQrsList } from "../../hooks";

import styles from "./Qrs.module.scss";

const Qrs = () => {
  const { t } = useTranslation();

  const {
    value: isNewQrModalOpen,
    setTrue: openNewQrModal,
    setFalse: closeNewQrModal
  } = useBoolean(false);

  const {
    value: isDeleteQrModalOpen,
    setTrue: openDeleteQrModal,
    setFalse: closeDeleteQrModal
  } = useBoolean(false);

  const [deletingQrId, setDeletingQrId] = useState<string | null>(null);

  const {
    searchValue,
    inventoryBoxesQrsList,
    isLoading,
    sorting,
    page,
    totalItems,
    setPage,
    setSorting,
    setSearchValue,
    refetchInventoryBoxesQrsList
  } = useInventoryBoxesQrsList();

  const onDeleteQrClick = (qrId: string) => {
    setDeletingQrId(qrId);
    openDeleteQrModal();
  };

  return (
    <div className={styles.qrs}>
      <div className={styles.qrs_headerControls}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={`${t("Search")}...`}
        />

        <Button
          title={`${t("Add New QR")}`}
          icon={<PlusInSquareIcon />}
          onClick={openNewQrModal}
        />
      </div>

      <div className={styles.qrs_tableContainer}>
        <InventoryBoxesQrsTable
          boxesQrsList={inventoryBoxesQrsList ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          refetchInventoryBoxesQrsList={refetchInventoryBoxesQrsList}
          onDeleteQr={onDeleteQrClick}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
        totalItems={totalItems}
      />

      <InventoryBoxQrModal
        isOpen={isNewQrModalOpen}
        onClose={closeNewQrModal}
        refetchInventoryBoxesQrsList={refetchInventoryBoxesQrsList}
      />

      <If condition={deletingQrId}>
        <DeleteInventoryBoxQrModal
          id={String(deletingQrId)}
          isOpen={isDeleteQrModalOpen}
          onClose={closeDeleteQrModal}
          onDeleteSuccess={refetchInventoryBoxesQrsList}
        />
      </If>
    </div>
  );
};

export default Qrs;
